function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
import { Constants as CONSTANTS } from './commons/list.constants.class';
import Api from './commons/api.class';
import Sort from './sort.class';
import Filters from './filters.class';
import SelectedFilters from './selectedFilters.class';
import { Pagination } from '@mozaic-ds/freemarker/js/modules/_pagination';
import FiltersLayer from "./filters-layer.class";
import { StoreContext } from "../storeContext/storeContext.class";
var List = /*#__PURE__*/_createClass(function List(config) {
  _classCallCheck(this, List);
  try {
    if (config.event === undefined || config.event === null) throw new Error('Paramètre event est obligatoire!');
    this.config = config;
    this.event = this.config.event;
    this.dataForApi = {};
    this.container = document.querySelector(".".concat(CONSTANTS.PRODUCT_LIST_SELECTORS.CONTAINER));
    this.api = new Api({
      url: this.config.url,
      headers: {
        resourcePath: this.config.resourcePath
      }
    });
    this.filtersInstance = null;
    this.paginationInstance = null;
    this.sortInstance = null;
    // listen the event of filters
    _listenEvent.call(this);
    // Initialize filters
    _initFilters.call(this);
    // Initialize Sorting
    _initSorting.call(this);
    // Initialize selected filters (tags above list elements )
    _initSelectedFilters.call(this);
    // Initialize pagination
    _initPagination.call(this);
    _initStoreContext.call(this);
  } catch (err) {
    console.error('Error : ', err);
  }
});
export default List;
function _initFilters() {
  this.filtersInstance = new Filters(this.config);
  new FiltersLayer();
}
function _initSorting() {
  this.sortInstance = new Sort(this);
}
function _initSelectedFilters() {
  new SelectedFilters(this);
}
function _initStoreContext() {
  var changeUserStoreButtons = this.container.querySelectorAll(".js-search_store-context button");
  new StoreContext(changeUserStoreButtons);
  new StoreContext(document.querySelectorAll("#customer_context_search_filter button"));
}
function _listenEvent() {
  document.addEventListener(this.event.key, _update.bind(this));
}
function _initPagination() {
  var _this = this;
  this.paginationInstance = new Pagination("".concat(CONSTANTS.PAGINATIONS.SELECTOR), function () {
    _paginate.call(_this);
  });
}
function _update(evt) {
  if (evt.detail.filters.sorting !== undefined && evt.detail.action === CONSTANTS.ACTION.SORT) {
    this.dataForApi.sort = evt.detail.filters.sorting;
  }
  if (evt.detail.lastSelectedFilter !== undefined) {
    this.config.lastSelectedFilter = evt.detail.lastSelectedFilter;
  }
  if (evt.detail.filters.p !== undefined && evt.detail.action === CONSTANTS.ACTION.PAGINATE) {
    this.dataForApi.p = evt.detail.filters.p;
  }
  //on recharge la page avec les filtres et on aplique directement un tri
  // on doit récupere touts les valuers des filtres sélectionné
  if (Object.keys(this.filtersInstance.selectedFilters).length > 0 && evt.detail.action !== CONSTANTS.ACTION.FILTER) {
    this.dataForApi.filters = this.filtersInstance.format(this.filtersInstance.selectedFilters).applieds;
  }
  if (evt.detail.filters !== undefined && evt.detail.action === CONSTANTS.ACTION.FILTER) {
    this.paginationInstance.currentPage = this.dataForApi.p = 1;
    if (Object.keys(evt.detail.filters).length > 0) {
      this.dataForApi.filters = evt.detail.filters.applieds;
    } else {
      delete this.dataForApi['filters'];
    }
  }
  _rewriteUrl.bind(this)();
  if (this.config.url && this.config.url !== null) {
    this.api.get({
      data: this.dataForApi,
      success: _displayResponseInView.bind(this),
      error: function error() {
        console.log('error api');
      }
    });
  }
}
function _displayResponseInView(data) {
  _parseData.call(this, data);
  this.filtersInstance = new Filters(this.config);
  _initSorting.call(this.config);
  _initSelectedFilters.call(this.config);
  _initStoreContext.call(this);
  _initPagination.call(this);
  _scrollToTop.call(this);
  lm.lazyload.observe();
  // Pagination event refresh tc vars
  var _tcVarsPaginationEvt = new CustomEvent('refreshTcVars', {
    'detail': {
      'callee': 'PAGINATION'
    }
  });
  document.dispatchEvent(_tcVarsPaginationEvt);
}
function _parseData(data) {
  var parser = new DOMParser();
  var parsedHtml = parser.parseFromString(data, 'text/html');
  var filtersHtml = parsedHtml.querySelector(".".concat(CONSTANTS.FILTERS_FORM_SELECTOR)).outerHTML;
  var listHtml = parsedHtml.querySelector(".".concat(CONSTANTS.PRODUCT_LIST_SELECTORS.CONTENT)).outerHTML;
  document.querySelector(".".concat(CONSTANTS.FILTERS_FORM_SELECTOR)).innerHTML = filtersHtml;
  this.container.querySelector(".".concat(CONSTANTS.PRODUCT_LIST_SELECTORS.CONTENT)).innerHTML = listHtml;
  var closeFiltersLayerButtonLabel = parsedHtml.querySelector(".".concat(CONSTANTS.FILTERS_LAYER_CLOSE_BUTTON)).innerHTML;
  document.querySelector(".".concat(CONSTANTS.FILTERS_LAYER_CLOSE_BUTTON)).innerHTML = closeFiltersLayerButtonLabel;
}
function _rewriteUrl() {
  var _ref = [window.location.pathname, '', '', '', ''],
    _urlEncoded = _ref[0],
    _urlEncodedFilters = _ref[1],
    _urlEncodedSorting = _ref[2],
    _urlEncodedPagination = _ref[3];
  var _titlePage = window.tc_vars.page_name;
  var haveFiltersApplieds = this.dataForApi.filters !== undefined;
  if (haveFiltersApplieds) {
    _urlEncodedFilters = "?".concat(encodeURIComponent('filters'), "=").concat(encodeURIComponent(this.dataForApi.filters));
  }
  if (this.dataForApi.sort !== undefined) {
    _urlEncodedSorting += "?".concat(encodeURIComponent('sort'), "=").concat(encodeURIComponent(this.dataForApi['sort']));
  }
  _urlEncodedPagination = this.paginationInstance !== null && this.dataForApi.p !== undefined ? "?p=".concat(this.paginationInstance.currentPage) : '';
  _urlEncoded = "".concat(_urlEncodedFilters).concat(_urlEncodedSorting).concat(_urlEncodedPagination);
  window.history.pushState({}, _titlePage, _urlEncoded);
}
function _paginate() {
  var data = {};
  data[this.event.dataKey] = {
    'p': this.paginationInstance.currentPage
  };
  this.event.target(_objectSpread({
    action: CONSTANTS.ACTION.PAGINATE
  }, data));
}
function _scrollToTop() {
  var htmlElem = document.querySelector('html');
  var bodyElem = document.querySelector('body');
  htmlElem.style.overflowX = 'visible';
  bodyElem.style.overflowX = 'visible';
  window.scrollTo(0, this.sortInstance.sortingElementPosition);
}